import { useRef, useState } from 'react';
import NewTabs from './NewTabs';
import List from './List';
import Filter from './filter/Filter';
import { connect, useSelector } from 'react-redux';
import { isMobile } from 'react-device-detect';
import AvailableUser from './available-user';
import { Loading } from '../loading';
import { ChannelCreditsAlert } from '../content/chat/ChannelCreditsAlert';
import { CustomerHasPaymentIntegratorProvider } from '../content/contexts/customerHasPaymentIntegrator/provider';
import { useWhiteLabel } from '../../../hooks/useWhiteLabel';
import { useGlotaT } from 'src/hooks/useGlotaTranslation';

function InProgressPanel({ isLoading, opennedChat, chat, settings }) {
  const mobile = useSelector((state) => state.chat.mobile);
  const [searching, setSearching] = useState(false);
  const containerRef = useRef(null);
  const loadingConversationsText = useGlotaT('spa.chat.loadingConversations');

  const isWL = useWhiteLabel().isWl;

  return (
    <>
      <CustomerHasPaymentIntegratorProvider customer_id={settings.customer_id}>
        <div
          className={`chatPanelContainer ${
            isMobile && (mobile?.blockOne ? '' : 'hidden')
          }`}
          id="chatPanelContainer"
        >
          <div className="chatPanelContainerHeader">
            {!isWL && (
              <ChannelCreditsAlert
                channelId={Number(opennedChat?.view?.selectedChannel?.id)}
              />
            )}
            <NewTabs />
          </div>
          <Filter screen={'currents'} onSearch={setSearching} />
          <AvailableUser />
          <div className="panel-divider"></div>
          <div
            className="chatListContainerMaster"
            id="chatListContainerMaster"
            ref={containerRef}
          >
            {isLoading || searching ? (
              <div style={{ height: '150px' }}>
                <Loading text={loadingConversationsText} />
              </div>
            ) : (
              <List whoGetList="inprogress" container={containerRef} />
            )}
          </div>
        </div>
      </CustomerHasPaymentIntegratorProvider>
    </>
  );
}

const mapStateToProps = (state) => ({
  opennedChat:
    state.chat?.chats?.filter((chat) => {
      return chat.open === true;
    })[0] || [],
  chat: state.chat?.chats?.find((chat) => chat.open === true),
  settings: state.chat?.config?.general?.settings,
});

export default connect(mapStateToProps)(InProgressPanel);
